export const needsSmallFont = (): boolean => {
  return true
}
